import { request } from "../network/request";
const db = "dn0";
export function getRlIdByTaskId(taskId) {
  return request({
    url: "pmp/cgw/getRlIdByTaskId",
    method: "post",
    params: {
      db, taskId
    },
  });
}
export function getCgwList(type, isTj) {
  return request({
    url: "pmp/cgw/selectCgwList",
    method: "post",
    params: {
      db, type, isTj
    },
  });
}

export function getCgwReviewInfo(taskId, rlId) {
  return request({
    url: 'pmp/cgw/getCgwReviewInfo',
    method: 'post',
    params: { db, taskId, rlId },
  })
}


export function deleteCgwFile(fileId, path) {
  return request({
    url: 'pmp/cgw/deleteCgwFile',
    method: 'post',
    params: { db, fileId, path },
  })
}

export function updateCgwFile(fileId, bz) {
  return request({
    url: 'pmp/cgw/updateCgwFile',
    method: 'post',
    params: { db, fileId, bz },
  })
}


export function saveCgwAndAudit(fileIds, taskId, bz, txlx, rwmc) {
  return request({
    url: "pmp/cgw/saveCgwAndAudit",
    method: "post",
    params: {
      db,
      fileIds, taskId, bz, txlx, rwmc
    },
  });
}


export function getCgwReviewList(params) {
  return request({
    url: "pmp/cgw/cgwReviewList",
    method: "post",
    params: {
      ...params,
    },
  });
}
export function cgwListExport(params) {
  return request({
    url: "pmp/cgw/exportCgwReviewList",
    method: "post",
    params,
  });
}

export function getCgwReviewerById(rlId) {
  return request({
    url: 'pmp/cgw/getCgwReviewerById',
    method: 'post',
    params: { db, rlId },
  })
}


export function updateCgwReviewer(taskId, rlId, reviewer, rwmc) {
  return request({
    url: "pmp/cgw/updateCgwReviewer",
    method: "post",
    params: {
      db,
      taskId, rlId, reviewer, rwmc
    },
  });
}

export function getCgwReviewerListByRlId(rlId) {
  return request({
    url: 'pmp/cgw/getCgwReviewerListByRlId',
    method: 'post',
    params: { db, rlId },
  })
}

export function getCgwYtjList(taskId, rlId) {
  return request({
    url: "pmp/cgw/selectCgwYtjList",
    method: "post",
    params: {
      db, taskId, rlId
    },
  });
}
export function getCgwPzYtjList(taskId, rlId) {
  return request({
    url: "pmp/cgw/selectCgwPzYtjList",
    method: "post",
    params: {
      db, taskId, rlId
    },
  });
}

export function saveCgwAudit(fileIds, id, rlId, taskId, status, isAdmin, ygbh, rwmc, txlx, bz) {
  return request({
    url: "pmp/cgw/saveCgwAudit",
    method: "post",
    params: {
      db,
      fileIds, id, rlId, taskId, status, isAdmin, ygbh, rwmc, txlx, bz
    },
  });
}






